function getReviewCount() {
  const container = document.querySelector('.stamped-container');
  const rawCount = container ? parseInt(container.getAttribute('data-count'), 10) : NaN;

  if (isNaN(rawCount)) {
    return '14,000';
  }

  const rounded = Math.floor(rawCount / 1000) * 1000;
  return rounded.toLocaleString('en-US');
}

function setReviewStatsBarCount() {
  const el = document.querySelector('.review-stats-bar__count');
  if (!el) return;
  el.textContent = `${getReviewCount()}+`;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setReviewStatsBarCount);
} else {
  setReviewStatsBarCount();
}
